import { css } from "@emotion/react";

export const validationSummary = css`
  margin-top: 2rem;
`;

export const phoneInput = css`
  width: 100%;
`;
